var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcSelect(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#595757",
    d: "M8 10h8l-4.001-6z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#595757",
    strokeWidth: 2,
    strokeLinejoin: "round",
    d: "M8 10h8l-4.001-6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#595757",
    d: "M8 14l4 6 4-6z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#595757",
    strokeWidth: 2,
    strokeLinejoin: "round",
    d: "M16 14H8l4.001 6z"
  }))));
}

export default "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg width='24px' height='24px' viewBox='0 0 24 24' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E %3Ctitle%3EGroup 55%3C/title%3E %3Cg id='SP75---Multiple-Pricing' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E %3Cg id='0.1.0-Pricing_1440' transform='translate(-940.000000, -2037.000000)'%3E %3Cg id='Token-Packs' transform='translate(152.000000, 1634.000000)'%3E %3Cg id='Group-18-Copy-19' transform='translate(576.000000, 138.000000)'%3E %3Cg id='Group-32' transform='translate(20.000000, 248.000000)'%3E %3Cg id='Group-55' transform='translate(192.000000, 17.000000)'%3E %3Crect id='Rectangle' x='0' y='0' width='24' height='24'%3E%3C/rect%3E %3Cg id='Group-7' transform='translate(8.000000, 4.000000)'%3E %3Cpolygon id='Fill-1' fill='%23595757' points='-0.0001 6.0002 7.9999 6.0002 3.9989 0.0002'%3E%3C/polygon%3E %3Cpolygon id='Stroke-2' stroke='%23595757' stroke-width='2' stroke-linejoin='round' points='0 6 8 6 3.999 0'%3E%3C/polygon%3E %3Cpolygon id='Fill-4' fill='%23595757' points='-0.0001 9.9998 4.0009 15.9998 7.9999 9.9998'%3E%3C/polygon%3E %3Cpolygon id='Stroke-5' stroke='%23595757' stroke-width='2' stroke-linejoin='round' points='8 10 0 10 4.001 16'%3E%3C/polygon%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/svg%3E";
export { SvgIcSelect as ReactComponent };